import React from 'react';
import styled from 'styled-components';

import RouterLink from 'components/basic/Link/RouterLink';
import { roundDownAtDecimals } from 'lib/numbers';

const Wrap = styled.div`
  color: var(--gray4c);
  font-size: var(--small);
  line-height: normal;
`;

/** Format rate and show without decimals (ie someone gets a 40.5% rate it shows as 40%) */
const formatRate = (value: string) =>
  roundDownAtDecimals(0, Number(value) * 100);

const rateIsMin1Percent = (value: string) => {
  return value && Number(value) >= 0.01;
};

interface Props {
  referralRateOverride: string | null | undefined;
  referredDiscountRateOverride: string | null | undefined;
  walletConnected: boolean;
  onClose?: () => void;
}

export default function BankrollCustomRates({
  referralRateOverride,
  referredDiscountRateOverride,
  walletConnected,
  onClose,
}: Props) {
  if (!referralRateOverride && !referredDiscountRateOverride) {
    return null;
  }
  return walletConnected ? (
    <Wrap>
      Share your referral code to{' '}
      {referralRateOverride && rateIsMin1Percent(referralRateOverride) ? (
        <b>earn {formatRate(referralRateOverride)}%</b>
      ) : (
        <b>earn rewards</b>
      )}{' '}
      on your followers&apos; trading fees. Followers get a{' '}
      {referredDiscountRateOverride &&
      rateIsMin1Percent(referredDiscountRateOverride) ? (
        <b>{formatRate(referredDiscountRateOverride)}% fee discount</b>
      ) : (
        <b>fee discount</b>
      )}{' '}
      when they sign up.
      <div style={{ paddingTop: 8 }}>
        <RouterLink
          to="/rewards/referrals"
          onClick={() => {
            onClose?.();
          }}
        >
          Get Your Code
        </RouterLink>
      </div>
    </Wrap>
  ) : (
    <Wrap>
      Connect your wallet to claim your referral code with a{' '}
      {referralRateOverride && rateIsMin1Percent(referralRateOverride) ? (
        <b>{formatRate(referralRateOverride)}% referral rewards rate</b>
      ) : (
        <b>boosted referral rewards rate</b>
      )}
      . Your followers will also receive a{' '}
      {referredDiscountRateOverride &&
      rateIsMin1Percent(referredDiscountRateOverride) ? (
        <b>{formatRate(referredDiscountRateOverride)}% discount</b>
      ) : (
        <b>discount</b>
      )}{' '}
      on trading fees.
    </Wrap>
  );
}
